import {Box, Divider, Flex, Heading, HStack, Text, useDisclosure, useMediaQuery, VStack} from "@chakra-ui/react";
import {OrderWithdrawModal, StyledButton} from "../../../../components";
import {ReactComponent as LinkIcon} from "../../../../assets/icons/profile/link-alt.svg";
import {ReactComponent as QrCode} from "../../../../assets/icons/qr_code.svg";
import {ReactComponent as ArrowRight} from "../../../../assets/icons/angle-right.svg";
import {BarChartWithFilters, DoughnutChart} from "../../../../components";

export const Overview = ({isMobile}) => {
    const [isSmallerThan991] = useMediaQuery("(max-width: 991px)")
    const [isSmallerThan1300] = useMediaQuery("(max-width: 1300px)")
    const {isOpen, onOpen, onClose} = useDisclosure()

    return (
        <Box>
            <Box
                borderRadius={'16px'}
                bg={{base: 'transparent',md:'neutral.1100'}}
                p={{base: '0',md:'32px'}}>
                <OrderWithdrawModal
                    isOpen={isOpen}
                    onClose={onClose}
                    />
                <HStack justify={'space-between'}>
                    <Heading fontSize={isMobile ? 'heading.xl':'heading.3xl'}>Referral Earnings & Statistics</Heading>
                    {!isMobile && <StyledButton w={'200px'} onClick={onOpen} rightIcon={<ArrowRight />}>Order withdrawal</StyledButton>}
                </HStack>
                <HStack
                    flexDirection={{ base: "column", md: "row" }}
                    gap={'16px'}
                    mt={'24px'}>
                    <Box
                        w={'full'}
                        p={'21px 16px'}
                        bg={'neutral.1000'}
                        borderRadius={'16px'}>
                        <Heading fontSize={{base: 'heading.md', md: 'heading.xl'}} mb={'8px'}>Total Referrals</Heading>
                        <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}}>300</Heading>
                    </Box>
                    <Box
                        w={'full'}
                        p={'21px 16px'}
                        bg={'neutral.1000'}
                        borderRadius={'16px'}>
                        <Heading fontSize={{base: 'heading.md', md: 'heading.xl'}} mb={'8px'}>Potential Earnings</Heading>
                        <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}}>$60,300</Heading>
                    </Box>
                    <Box
                        w={'full'}
                        p={'21px 16px'}
                        bg={'neutral.1000'}
                        borderRadius={'16px'}>
                        <Heading fontSize={{base: 'heading.md', md: 'heading.xl'}} mb={'8px'}>Current Balance</Heading>
                        <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}}>$60,300</Heading>
                    </Box>
                    <Box
                        w={'full'}
                        p={'21px 16px'}
                        bg={'neutral.1000'}
                        borderRadius={'16px'}>
                        <Heading fontSize={{base: 'heading.md', md: 'heading.xl'}} mb={'8px'}>Withdrawals Ordered</Heading>
                        <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}}>$60,300</Heading>
                    </Box>
                </HStack>
            </Box>
            <Box
                mt={'24px'}
                borderRadius={'16px'}
                bg={'neutral.1100'}
                p={{base: '16px',md:'32px'}}>
                <HStack
                    flexDirection={isSmallerThan991 ? 'column' : 'row'}
                    justifyContent={'space-evenly'}>
                    <VStack
                        maxW={isSmallerThan1300 ? '300px':'467px'}
                        flex={'1'}
                        m={isSmallerThan1300 ? '20px' :'51px 44px'}
                        p={'32px 16px'}
                        borderRadius={'16px'}
                        gap={'24px'}
                        border={'1px solid #23262F'}>
                        <HStack
                            w={'full'}
                            bg={'neutral.900'}
                            borderRadius={'8px'}>
                            <LinkIcon />
                            <Text>http://aasfgghfghjgh</Text>
                        </HStack>
                        <VStack
                            w={'full'}
                            alignItems={'start'}
                            flexDirection={{base: 'row-reverse', md: 'column'}}>
                            <Text fontSize={{base: 'body.sm', md: 'body.md'}}>Automatically generate a QR code for affiliates</Text>
                            <Box>
                                <QrCode />
                            </Box>
                        </VStack>
                    </VStack>
                    <HStack
                        flex={'1'}
                        flexDirection={isSmallerThan991 ? 'column-reverse' : 'row'}>
                        <Box w={'full'} mt={{base: '24px', md: '0'}}>
                            <DoughnutChart />
                        </Box>
                        <Box>
                            {
                                isSmallerThan991 ? (
                                    <>
                                        <HStack>
                                            <Box
                                                borderRadius={'8px'}
                                                w={'62px'}
                                                p={'12px'}
                                                bg={'purple.500'}>
                                                20%
                                            </Box>
                                            <Divider
                                                orientation='horizontal'
                                                borderColor={'purple.500'}/>
                                            <Box
                                                borderRadius={'8px'}
                                                w={'62px'}
                                                p={'12px'}
                                                bg={'purple.500'}>
                                                15%
                                            </Box>
                                        </HStack>
                                        <HStack gap={'24px'}>
                                            <Text>Current Referral Level</Text>
                                            <Text>Next Level Unlock Criteria</Text>
                                        </HStack>
                                    </>
                                ) : (
                                    <>
                                        <HStack>
                                            <Box
                                                borderRadius={'8px'}
                                                w={'62px'}
                                                p={'12px'}
                                                bg={'purple.500'}>
                                                20%
                                            </Box>
                                            <Text whiteSpace={'nowrap'}>Current Referral Level</Text>
                                        </HStack>
                                        <Divider
                                            my={'8px'}
                                            ml={'31px'}
                                            h={'50px'}
                                            orientation='vertical'
                                            borderColor={'purple.500'}/>
                                        <HStack>
                                            <Box
                                                borderRadius={'8px'}
                                                w={'62px'}
                                                p={'12px'}
                                                bg={'purple.500'}>
                                                15%
                                            </Box>
                                            <Text whiteSpace={'nowrap'}>Next Level Unlock Criteria</Text>
                                        </HStack>
                                    </>
                                )
                            }
                        </Box>
                    </HStack>
                </HStack>
            </Box>
            <Flex
                w={'full'}
                flexDirection={isSmallerThan991 ? 'column' : 'row'}
                gap={'16px'}
                mt={'24px'}>
                <Box
                    flex={1}
                    p={'24px'}
                    borderRadius={'16px'}
                    bg={'neutral.1100'}>
                    <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}} fontWeight={'500'} mb={'24px'}>Referral Registration</Heading>
                    <BarChartWithFilters />
                </Box>
                <Box
                    p={'24px'}
                    flex={1}
                    borderRadius={'16px'}
                    bg={'neutral.1100'}>
                    <Heading fontSize={{base: 'heading.xl', md: 'heading.3xl'}} fontWeight={'500'} mb={'24px'}>Referral Purchases</Heading>
                    <BarChartWithFilters />
                </Box>
            </Flex>
        </Box>
    )
}